import React, { useEffect, useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

function ExceptionsExpenses() {
  const navigation=useNavigate()
          const { currentLocal } = useSelector((state) => state.currentLocal);
                        const userinfo = useSelector((state) => state);
          
          const {id}=useParams()

              const [items, setItems] = useState([])
              const [item, setItem] = useState([])

    const headerIterm = [
        currentLocal.home.ID,
        // currentLocal.home.image,


        currentLocal.home.nameStudent,
        currentLocal.home.stageName,
        currentLocal.home.gradeName,
        currentLocal.home.ressonOfException,
        currentLocal.home.price,
        "",

   ]
      useEffect(() => {
const getData=async()=>{

try {
            await axios
                .get(`https://nanosoft.space/taarteb/public/api/admin/expenses/${id}/exceptions`, {
                    headers: {
                        Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                    }
                })
                .then(async (res) => {
                  setItem(res.data.data.expense)

setItems(res.data.data.exceptions)
                })
                .catch((error) => {


                });
} catch (error) {
  console.log(error);
  
}
}
getData()
   }, [])
     const printTable = () => {
        const content = document.getElementById("financialTable").innerHTML;

        const printWindow = window.open("", "_blank", "width=900,height=700");
        printWindow.document.write(`
    <html dir="rtl">
      <head>
        <title>${currentLocal.home.FinanceReport}</title>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
        <style>
          body {
            font-family: Arial, sans-serif;
            direction: rtl;
            padding: 20px;
          }
          .fw-bold {
            font-weight: bold;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          table, th, td {
            border: 1px solid #000;
          }
          th, td {
            padding: 8px;
            text-align: center;
          }
          th {
            background-color: #f8f8f8;
          }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };   

    const body=<tbody>

    {items?.map((item, index) => {
console.log(item,"itemitemitemitemitemitemitemitemitemitem");
      return (
        <tr key={index}>
          <td>{item?.id}</td>
          {/* <td>{item?.image?
          <img src={item?.image}alt=""className='w-100'/>
          :"_"}</td> */}
          <td>{item?.name}</td>
          <td>{item.grade_category_name}</td>
          <td>{item?.grade_name}</td>
          <td>{item?.pivot?.notes}</td>
          <td>{item?.pivot?.exception_price}{" "}{currentLocal.home.currancy}</td>
          <td>
<button onClick={()=>{
navigation(`/dashboard/expenses/exceptions/${id}/edite/${item?.id}`)
}}>


    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                          </svg>
</button>
          </td>



</tr>
      )
    })}

      </tbody>
  return (
    <div className="px-0 my-3 w-100 dashboard_content">
    <Container>
        <div className="d-flex flex-column w-100">
            
            <AuthNavbar />
            <div className="mt-5 mx-3">
                <HomeTitle title={currentLocal.home.Studyexpenses} />
                <p className='fw-bold'>{item?.grade_category?.name}{" "}{item?.grade?.name}</p>
                <p className='fw-bold'>{currentLocal.home.mainexpenses} : {item?.price}</p>

                {/* <ExportBox
                                   title={""}
                    paragrapg={' '}
                    addingBtn={currentLocal.home.add}
                    exportState={false}
                /> */}
                <Row>
                  <div>
                          <button onClick={printTable} className="btn  border mb-3 mt-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
                                <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                            </svg>
                        </button>
                  </div>

</Row>
                        <div id="financialTable">

                <Table
                    data={items}
                    headerIterm={headerIterm}
                    actions={["edit"]}
                    acceptStatus={`expenses/exceptions/${id}`}
                    body={body}
                    onSubmitAttendance={() => { }}
                    // onDataChanged={getAllApis}
                />
                </div>


            </div>

        </div>
    </Container>
</div>)
}

export default ExceptionsExpenses